import { globalRef, type Unsubscribe } from '@amazon/vinyl-util'

const listenersRef = globalRef(() => new Set<() => void>())

/** Runs for a link press that does not navigate in-app (external, new-tab, modified click). */
export function onExternalLinkPress(handler: () => void): Unsubscribe {
    listenersRef.value.add(handler)
    return () => {
        listenersRef.value.delete(handler)
    }
}

export function announceExternalLinkPress(): void {
    for (const handler of [...listenersRef.value]) handler()
}
